import { type ComponentProps, memo } from 'react';

import { cn } from '@air/utils-tailwind';

export type VersionsListHeaderProps = Pick<ComponentProps<'header'>, 'className'> & {
  title: string;
};

export const VersionsListHeader = memo(({ className, title }: VersionsListHeaderProps) => {
  return (
    <header className={cn('flex h-4 items-center px-2', className)} data-testid="VERSIONS_LIST_HEADER">
      <h2
        className="truncate font-bold ads:text-metadata text-10 text-gray-10 uppercase"
        data-testid="VERSIONS_LIST_HEADER_TITLE"
      >
        {title}
      </h2>
    </header>
  );
});

VersionsListHeader.displayName = 'VersionsListHeader';
